import { exchangeRates } from './propertyData';


export const formatCurrency = (amount, currency) => {
  const formatOptions = {
    AED: { symbol: 'AED', locale: 'en-AE', decimals: 2 },
    INR: { symbol: '₹', locale: 'en-IN', decimals: 0 }
  };


  const config = formatOptions[currency];
  
  return new Intl.NumberFormat(config.locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: config.decimals,
    maximumFractionDigits: config.decimals
  }).format(amount);
};


export const convertPrice = (aedAmount) => {
  return {
    aed: aedAmount,
    inr: aedAmount * exchangeRates.AED_TO_INR
  };
};


export const getMultiCurrencyPrice = (aedAmount) => {
  const prices = convertPrice(aedAmount);
  return {
    aed: formatCurrency(prices.aed, 'AED'),
    inr: formatCurrency(prices.inr, 'INR'),
    combined: `${formatCurrency(prices.aed, 'AED')} / ${formatCurrency(prices.inr, 'INR')}`
  };
}; 
